module.exports = import("https://www.gstatic.com/firebasejs/11.3.1/firebase-storage.js");;